<template>
  <Teleport to="body">
    <iModal
      :visible="open"
      :max-width="750"
      title="Select a Collection"
      :show-primary-action-button="false"
      @close="closeModal"
    >
      <iColumn>
        <iRow>
          <iRow>
            <iTextEditInput
              v-model="createCollectionName"
              clear-value-on-submit
              clear-value-on-cancel
              display-actions-as-block
              editable-on-click
              placeholder="Create A New Collection"
              :is-loading="isLoading"
              @submit="createNewCollection"
            />
          </iRow>
        </iRow>
        <SmartFeed
          default-smart-feed-layout="grid"
          default-entity-layout="cardSmall"
          :pinia-store="useCollectionFeedStore"
        >
          <template #empty-state>
            <iText variant="subtle">
              There are no collections.
            </iText>
          </template>
        </SmartFeed>
      </iColumn>
    </iModal>
  </Teleport>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { DEFAULT_COLLECTION_COVER_IMAGE } from "@/constants/affiliate-constants";
import SmartFeed from "SmartFeed/components/SmartFeed.vue";
import { useCollectionFeedStore } from "SmartFeed/stores/feed/collection-feed-store";
import { useCollectionStore } from "~/stores/collection-store";

export default {
  name: "SelectCollection",
  components: { SmartFeed },
  props: {
    itemId: {
      type: Number,
      required: true,
    },
    itemContext: {
      type: String,
      default: "story",
      required: true,
    },
    open: {
      type: Boolean,
      required: true,
    },
    context: {
      type: String,
      required: true,
    },
  },
  emits: ["select", "close"],
  data() {
    return {
      DEFAULT_COLLECTION_COVER_IMAGE,
      addingCollection: false,
      createCollectionName: "",
      selectedCollectionItemId: null,
    };
  },
  computed: {
    ...mapState(useCollectionStore, [
      "loadingItem",
    ]),
    ...mapWritableState(useCollectionFeedStore, [
      "metadata",
    ]),
    ...mapWritableState(useCollectionStore, [
      "collectionItemId",
    ]),
    isLoading() {
      return this.loadingFetchCollectionsContainingLink || this.loadingFetchAffiliateLinkCollections;
    },
  },
  watch: {
    collectionItemId(newValue) {
      if (newValue) {
        this.selectedCollectionItemId;
      }
    },
  },
  created() {
    this.metadata.itemId = this.itemId;
    this.metadata.itemContext = this.itemContext;
  },
  methods: {
    useCollectionFeedStore,
    ...mapActions(useCollectionStore, [
      "createCollection",
    ]),
    closeModal() {
      this.$emit("close");
    },
    async createNewCollection(name) {
      this.isLoading = true;
      await this.createCollection({
        name: name,
        description: "",
        cover_image_url: "",
        visibility: "public",
        item_id: this.itemId,
        item_context: this.itemContext,
        context: this.context,
      }).then(() => {
        this.isLoading = false;
        this.createCollectionName = "";
      }).finally(() => {
        this.metadata.lastId = 0;
        useCollectionFeedStore().reload({ metadata: this.metadata });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.pointer {
  cursor: pointer;
}
</style>
